import { usePageScroll } from '@hooks/usePageScroll';
import { useSentinelPhase } from '@hooks/useSentinelPhase';
import { FormattedMessage } from 'react-intl';

import './Breadcrumb.css';

export default function Breadcrumb() {
	const { getPhaseClassName } = useSentinelPhase();
	const { scrollToElement } = usePageScroll();

	const handleClick = (phase: string) => (e: React.MouseEvent) => {
		e.preventDefault();
		scrollToElement(phase);
	};

	return (
		<nav id="sidebar-breadcrumb">
			<a href="#detect" className={getPhaseClassName('detect')} onClick={handleClick('detect')}>
				<FormattedMessage id="sentinel.sidebar-breadcrumb.detect" />
			</a>
			<a href="#verify" className={getPhaseClassName('verify')} onClick={handleClick('verify')}>
				<FormattedMessage id="sentinel.sidebar-breadcrumb.verify" />
			</a>
			<a href="#respond" className={getPhaseClassName('respond')} onClick={handleClick('respond')}>
				<FormattedMessage id="sentinel.sidebar-breadcrumb.respond" />
			</a>
		</nav>
	);
}
